var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.121 17.897a8.764 8.764 0 00-1.889-2.8 8.804 8.804 0 00-2.8-1.89c-.01-.005-.02-.007-.029-.012A5.811 5.811 0 0012 2.672a5.811 5.811 0 00-3.403 10.526l-.028.011a8.727 8.727 0 00-2.801 1.89 8.804 8.804 0 00-1.889 2.8 8.712 8.712 0 00-.691 3.237.188.188 0 00.187.192h1.406a.187.187 0 00.188-.183 6.988 6.988 0 012.058-4.788A6.985 6.985 0 0112 14.297c1.88 0 3.645.731 4.974 2.06a6.988 6.988 0 012.057 4.788.186.186 0 00.188.183h1.406c.105 0 .19-.087.188-.192a8.732 8.732 0 00-.692-3.24zm-8.12-5.381a4.005 4.005 0 01-2.85-1.182 4.005 4.005 0 01-1.182-2.85 4.01 4.01 0 011.181-2.85A4.005 4.005 0 0112 4.454c1.076 0 2.088.419 2.85 1.18a4.005 4.005 0 011.181 2.85 4.01 4.01 0 01-1.18 2.85A4.005 4.005 0 0112 12.516z",
    fill: "#E84E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.6949a523ebc91e2aa8729b485312c093.svg";
export { ForwardRef as ReactComponent };